import api from './api';

export const getAllOrders = async () => {
    const res = await api.get('/Order');
    return res.data;
};

export const getOrdersByProject = async (projectId) => {
    const res = await api.get(`/Order/project/${projectId}`);
    return res.data;
};

export const getProjectHoursSummary = async (projectId) => {
    const res = await api.get(`/Order/project/${projectId}/summary`);
    return res.data;
};

export const createOrder = async (dto) => {
    const res = await api.post('/Order', dto);
    return res.data;
};

export const updateOrder = async (orderId, dto) => {
    const res = await api.patch(`/Order/${orderId}`, dto);
    return res.data;
};

export const deleteOrder = async (orderId) => {
    const res = await api.delete(`/Order/${orderId}`);
    return res.data;
};

/** Attach a document (order confirmation, PO, scope) to an order. */
export const uploadOrderFile = async (orderId, file) => {
    const data = new FormData();
    data.append('file', file);
    const res = await api.post(`/Order/${orderId}/file`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
};

/** The attached document as a Blob. Through the API, not a presigned URL: the iframe preview
 *  cannot send X-API-Key, so the caller turns this into an object URL. */
export const getOrderFile = async (orderId) => {
    const res = await api.get(`/Order/${orderId}/file`, { responseType: 'blob' });
    return res.data;
};

export const deleteOrderFile = async (orderId) => {
    const res = await api.delete(`/Order/${orderId}/file`);
    return res.data;
};
